import React from 'react';
import { radiusMix } from './radiusAlign';
import { useRadius } from './RadiusContext';
import { RADIUS_LEVELS } from './radiusTypes';

/* The report's evidence mix, above the prose it describes.
   Counts come from the API's own `distribution`, never from the spans we
   managed to place, so a sentence we failed to locate still shows up here. */

const RadiusLedger: React.FC = () => {
  const { block, enabled } = useRadius();
  const mix = radiusMix(block);

  if (!enabled || !mix.total) return null;

  const consumers = block?.corpus_consumers;
  const corpusSize = block?.corpus_size;

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-white px-[18px] py-4">
      <div className="mb-2.5 flex flex-wrap items-baseline justify-between gap-4">
        <span className="text-[10px] font-semibold uppercase tracking-[0.1em] text-[#012e2a]">
          Where this report comes from
        </span>
        <span className="text-[11px] tabular-nums text-gray-500">
          <span className="font-semibold text-gray-900">{mix.total}</span>
          {` generated sentences traced to source${
            consumers ? ` across ${consumers} consumers` : ''
          }${consumers && corpusSize ? ` (${corpusSize} responses)` : ''}`}
        </span>
      </div>

      <div className="flex h-1.5 overflow-hidden rounded-full bg-gray-200" aria-hidden="true">
        {RADIUS_LEVELS.map((level, index) =>
          mix.counts[index] ? (
            <span
              key={level.level}
              className="block h-full"
              style={{ width: `${mix.pct[index]}%`, backgroundColor: level.color }}
            />
          ) : null,
        )}
      </div>

      <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-1.5">
        {RADIUS_LEVELS.map((level, index) => (
          <li key={level.level} className="flex items-center gap-[7px] text-[11px] text-gray-500">
            <span
              className="h-2 w-2 flex-none rounded-sm"
              style={{ backgroundColor: level.color }}
              aria-hidden="true"
            />
            <span className="font-semibold tabular-nums text-gray-900">{mix.counts[index]}</span>
            {level.label}
            <span className="tabular-nums text-gray-400">{Math.round(mix.pct[index])}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RadiusLedger;
